import * as React from 'react';
import {
  NODE_PARAGRAPH,
  MARK_LINK,
  render,
} from 'storyblok-rich-text-react-renderer';
import LinkResolver from '../../helpers/link-resolver';
import { getStoryblokAlt } from '../../helpers/common';

export function renderReferenceRichText(content, className = '') {
  if (!content) return null;

  return (
    <div className={className}>
      {render(content, {
        markResolvers: {
          [MARK_LINK]: LinkResolver,
        },
        nodeResolvers: {
          [NODE_PARAGRAPH]: (children) => (
            <p className="first-of-type:mt-0 mt-4 text-[16px] leading-[24px]">{children}</p>
          ),
        },
      })}
    </div>
  );
}

function getStoryblokDimensions(filename) {
  const [width, height] = filename?.split('/')[5]?.split('x') || [];
  return {
    width: Number(width) || undefined,
    height: Number(height) || undefined,
  };
}

function getStoryblokImageUrl(filename, width = 1200, format = 'webp') {
  if (!filename || filename.includes('.svg') || !filename.includes('a.storyblok.com')) {
    return filename;
  }

  return `${filename}/m/${width}x0/filters:format(${format})`;
}

function getStoryblokImageSrcSet(filename, widths, format = 'webp') {
  if (!filename || filename.includes('.svg') || !filename.includes('a.storyblok.com')) {
    return undefined;
  }

  return widths.map((width) => `${getStoryblokImageUrl(filename, width, format)} ${width}w`).join(', ');
}

export function StoryblokResponsiveImage({
  image,
  alt,
  className,
  sizes,
  defaultWidth = 1024,
  widths = [480, 768, 1024, 1440],
}) {
  if (!image?.filename) return null;

  const { width, height } = getStoryblokDimensions(image.filename);

  return (
    <picture>
      <source
        type="image/avif"
        srcSet={getStoryblokImageSrcSet(image.filename, widths, 'avif')}
        sizes={sizes}
      />
      <img
        src={getStoryblokImageUrl(image.filename, defaultWidth)}
        srcSet={getStoryblokImageSrcSet(image.filename, widths)}
        sizes={sizes}
        alt={getStoryblokAlt(image, alt || '')}
        width={width}
        height={height}
        className={className}
        loading="lazy"
        decoding="async"
      />
    </picture>
  );
}

export function hasStoryblokLink(link) {
  if (!link || typeof link !== 'object') return false;

  return Boolean(
    link.cached_url
      || link.url
      || link.story
      || link.email
      || link.anchor,
  );
}
